import React, { useState } from "react";
import { api } from "../lib/api";
import { Mail, Send } from "lucide-react";
import { toast } from "sonner";

export const SubscribeForm = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    try {
      const { data } = await api.post("/subscribe", { email, source: "homepage" });
      if (data.already_subscribed) {
        toast.info("You’re already on the list — thank you!");
      } else {
        toast.success("Welcome to the family! 🧶");
      }
      setDone(true);
      setEmail("");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Could not subscribe");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section
      id="subscribe"
      className="w-full py-16 md:py-20 px-6"
      style={{ backgroundColor: "var(--bg-primary)" }}
      data-testid="subscribe-section"
    >
      <div className="max-w-2xl mx-auto text-center">
        <div
          className="inline-flex items-center gap-2 rounded-full px-4 py-1.5 mb-5"
          style={{ backgroundColor: "var(--brand-peach)", color: "var(--text-accent)" }}
        >
          <Mail size={14} />
          <span className="text-xs uppercase tracking-[0.25em] font-semibold">Stay in the loop</span>
        </div>
        <h2
          className="font-display text-3xl md:text-4xl lg:text-5xl mb-4 leading-tight"
          style={{ color: "var(--text-primary)" }}
        >
          New plushies, dropped in your inbox
        </h2>
        <p className="text-base md:text-lg mb-7" style={{ color: "var(--text-secondary)" }}>
          A gentle little note whenever a new batch is ready. No spam, ever — pinky-promise.
        </p>

        <form
          onSubmit={onSubmit}
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          data-testid="subscribe-form"
        >
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="flex-1 px-5 py-3 rounded-full outline-none text-sm"
            style={{
              backgroundColor: "#fff",
              border: "1px solid var(--border-soft)",
              color: "var(--text-primary)",
            }}
            data-testid="subscribe-email-input"
          />
          <button
            type="submit"
            disabled={busy}
            className="btn-sage inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full text-sm font-semibold tracking-wide uppercase disabled:opacity-60"
            data-testid="subscribe-submit-button"
          >
            <Send size={14} />
            {busy ? "Joining…" : "Subscribe"}
          </button>
        </form>

        {done && (
          <p
            className="font-script text-xl mt-4"
            style={{ color: "var(--brand-sage)" }}
            data-testid="subscribe-success-message"
          >
            you’re in — thank you ♥
          </p>
        )}
      </div>
    </section>
  );
};

export default SubscribeForm;
